import { Controller } from "@hotwired/stimulus";
import { loadStripe } from "@stripe/stripe-js";
import { Stripe } from "stripe";

// Present in app/views/carts/checkout.turbo_stream.erb.
// Connects to data-controller="stripe-checkout"
export default class extends Controller {
  static values = {
    publicKey: String,
    clientSecret: String,
  };

  connect() {
    // Boots the embedded checkout as soon as the element enters the DOM.
    this.renderEmbeddedCheckout();
  }

  disconnect() {
    // Destroy Stripe resources when Turbo removes the element.
    this.unmountEmbeddedCheckout();
  }

  clientSecretValueChanged() {
    // Reload checkout when Turbo replaces the client secret (e.g. new cart total).
    this.unmountEmbeddedCheckout();
    this.renderEmbeddedCheckout();
  }

  async renderEmbeddedCheckout() {
    // Skip work until both values are provided or a render is already happening.
    if (!this.hasPublicKeyValue || !this.hasClientSecretValue) return;
    if (this.rendering) return;

    this.rendering = true;

    try {
      // Lazily fetch the Stripe instance so we only load it once per page.
      this.stripe = this.stripe || (await loadStripe(this.publicKeyValue));
      if (!this.stripe) {
        console.error("Stripe failed to initialize");
        return;
      }

      // Embedded checkout replaces any previous placeholder markup.
      this.element.innerHTML = "";

      this.checkout = await this.stripe.initEmbeddedCheckout({
        clientSecret: this.clientSecretValue,
      });

      await this.checkout.mount(this.element);

    } catch (error) {
      console.error("Failed to mount Stripe Embedded Checkout", error);
    } finally {
      this.rendering = false;
    }
  }

  unmountEmbeddedCheckout() {
    if (this.checkout) {
      // Destroy removes event listeners and iframe injected by Stripe.
      this.checkout.destroy();
      this.checkout = null;
    }
  }
}
